import React, { useContext } from 'react';
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Header from './components/Header';
import Footer from './components/Footer';
import Pocetna from './components/Pocetna';
import Oglasi from './components/Oglasi';
import ZavrsniRadovi from './components/ZavrsniRadovi';
import OglasExpanded from './components/OglasExpanded';
import styles from './components/Common.module.css';
import { ThemeContext } from './contexts/ThemeContext';
import ZavrsniRadExpanded from './components/ZavrsniRadExpanded';

function App() {
  const { dark } = useContext(ThemeContext);

  return (
      <div className={dark?styles.appDark:styles.appLight}>
        <BrowserRouter basename='/simple'>
          <Header />
            <Switch>
              <Route path="/oglasi/godina/:godinaId/oglas/:oglasId" component={OglasExpanded} />
              <Route path="/zavrsni-radovi/:radId" component={ZavrsniRadExpanded} />
              <Route path="/oglasi" component={Oglasi} />
              {/*<Route path="/raspored" component={Raspored} />*/}
              <Route path="/zavrsni-radovi" component={ZavrsniRadovi} />
              <Route path="/" component={Pocetna} />
            </Switch>
          <Footer />
        </BrowserRouter>
      </div>
  );
}

export default App;
